import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

export const SignUpBox = () => {
  const [dismissed, setDismissed] = useState(() => localStorage.getItem("rinova_signup_dismissed") === "1");
  const [openForm, setOpenForm] = useState(false);
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);
  if (dismissed) return null;

  const close = () => {
    localStorage.setItem("rinova_signup_dismissed", "1");
    setDismissed(true);
  };

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/newsletter", { phone });
      toast("You're signed up for texts");
      close();
    } catch (err) {
      toast(err?.response?.data?.detail || "Please enter a valid number");
    } finally { setBusy(false); }
  };

  if (openForm) {
    return (
      <div data-testid="signup-box" className="fixed bottom-5 right-5 z-40 bg-white p-4 w-[260px]" style={{ boxShadow: "0 0 0 1px rgba(0,0,0,0.1)" }}>
        <div className="flex items-center justify-between mb-3">
          <span className="util-link text-[11px] tracking-[0.08em] text-black">SIGN UP FOR TEXTS</span>
          <button data-testid="signup-close" onClick={close} aria-label="Dismiss" className="text-black text-base leading-none link-hover w-6 h-6">×</button>
        </div>
        <form onSubmit={submit} className="flex items-center gap-2">
          <input data-testid="signup-phone" type="tel" value={phone} onChange={(e) => setPhone(e.target.value)}
            placeholder="Phone number" className="flex-1 bg-transparent border-b border-black py-1.5 text-sm outline-none" />
          <button data-testid="signup-submit" disabled={busy} className="util-link text-[11px] link-hover">→</button>
        </form>
      </div>
    );
  }

  return (
    <div data-testid="signup-box" className="fixed bottom-5 right-5 z-40 bg-white flex items-center justify-between px-4 w-[160px] h-[40px] sm:w-[200px] sm:h-[44px]" style={{ boxShadow: "0 0 0 1px rgba(0,0,0,0.1)" }}>
      <button data-testid="signup-open" onClick={() => setOpenForm(true)} className="util-link text-[11px] tracking-[0.08em] text-black link-hover">SIGN UP FOR TEXTS</button>
      <button data-testid="signup-close" onClick={close} aria-label="Dismiss" className="text-black text-base leading-none link-hover -mr-2 w-8 h-full flex items-center justify-center">×</button>
    </div>
  );
};
